import qfSignals from "quickfire/qf-signals";
import { VEventEnum, WagerLimitReasons } from "quickfire/v/enums";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import { Autoplay } from "slotworks/services/autoplay/autoplay";
import { AddWindowFocusChangeListener } from "slotworks/utils/browser-utils";
import Contract from "slotworks/utils/contracts/contract";
import DeviceInfo from "slotworks/utils/device-info";

export class VAutoplay extends Autoplay {

    constructor() {
        super();

        qfSignals.get(VEventEnum.autoPlayInterrupt).add(() => this.stop());
    }

    public start() {
        V.API.Autoplay.init({
            lossLimit: AutoplayModel.lossLimit.currentValue,
            selectedBetSize: BetModel.getTotalStake(),
            spins: AutoplayModel.autoplays.currentValue,
            winLimit: AutoplayModel.singleWinLimit.currentValue
        } as any, () => 0, () => 0, this);

        qfSignals.dispatch(VEventEnum.autoPlayStarted);

        // Called once to force wager limit API to count the first spin
        V.API.Autoplay.verifyWagerLimits(this.getWagerParameters());

        super.start();
    }

    public spin() {
        AutoplayModel.decrease();
    }

    public updateWinLoss() {
        if (AutoplayModel.isAutoPlaying()) {

            const result = V.API.Autoplay.verifyWagerLimits(this.getWagerParameters());
            if (result) {
                if (result.autoPlayLimitReached) {
                    if (result.limit === WagerLimitReasons.wagerCount) {
                        this.complete();
                    } else {
                        const lossLimit = result.limit === WagerLimitReasons.lossLimit;
                        const singleWinLimit = false;
                        const totalWinLimit = result.limit === WagerLimitReasons.winLimit;

                        return this.limitReached(lossLimit, singleWinLimit, totalWinLimit, result.messageText);
                    }
                }
            }
        }

        return Contract.empty();
    }

    public stop() {
        if (AutoplayModel.isAutoPlaying()) {
            qfSignals.dispatch(VEventEnum.autoPlayStopped);
        }

        super.stop();
    }

    public complete() {
        qfSignals.dispatch(VEventEnum.autoPlayStopped);

        super.complete();
    }

    private getWagerParameters(): VerifyWagerLimitsParameters {
        let win = 0;
        if (GameState.getCurrentGame().hasRecords()) {
            win = GameState.getCurrentGame().getCurrentTotalWin();
        }
        const stake = BetModel.freeBet ? 0 : BetModel.getTotalStake();

        return {
            nextBetAmount: stake,
            previousWinAmount: win,
            isTriggeredEffect: false
        };
    }
}
